export default __webpack_public_path__ + "locales/el-GR/DeleteDialog.json?hash=b767968afd7fc7d8a8a28c414c65f228";